import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { T } from 'shared/helper/translate';
import RubriqSelectedCriteria from './RubriqSelectedCriteria';
import RubriqSetupStepBackLink from './RubriqSetupStepBackLink';
var RubriqSetupConfirmationStep = function RubriqSetupConfirmationStep(_ref) {
  var startTemplate = _ref.startTemplate,
    session = _ref.session,
    previousStep = _ref.previousStep,
    submitting = _ref.submitting;
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-2"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "fw-semibold"
  }, /*#__PURE__*/React.createElement(T, {
    source: "your criteria"
  })), /*#__PURE__*/React.createElement("p", {
    className: "p-0 m-0 text-secondary"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.abstract-criteria-confirmation-step-description"
  }))), /*#__PURE__*/React.createElement(RubriqSelectedCriteria, null)), /*#__PURE__*/React.createElement("div", {
    className: "alert alert-block alert-warning ps-4 mb-0"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.abstract-criteria-confirmation-step-warning"
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between gap-3"
  }, /*#__PURE__*/React.createElement(RubriqSetupStepBackLink, {
    session: session,
    previousStep: previousStep
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary btn-squared py-1 px-sm-5 w-mobile-50",
    onClick: function onClick() {
      return startTemplate();
    },
    disabled: submitting
  }, /*#__PURE__*/React.createElement(T, {
    source: "confirm"
  }), submitting && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    className: "ms-1",
    spin: true
  }))));
};
export default RubriqSetupConfirmationStep;